import { gql } from '@apollo/client'

export default gql`
  query mortgageWidgetSubmission($uuid: String, $productTypes: [MortgageWidgetProductTypeEnum!]) {
    mortgageWidgetSubmission(uuid: $uuid) {
      uuid
      ficoType
      vertical
      zipCode
      estimatedValue
      status
      downPayment
      homeValue
      loanAmount
      occupancyType
      propertyType
      cashOut
      products (productTypes: $productTypes){
        discount
        uuid
        externalProductId
        lender {
          name
          nmls
          slug
        }
        monthlyPayment
        productType
        loanTerm
        amortizationType
        rate
        apr
        fees
        bestProduct
      }
    }
  }
`
